module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-layout-top",
    class: [_vm.alignClass, _vm.typeClass, _vm.sizeClass, _vm.layoutClass, _vm.fullWidthClass]
  }, [_c('ul', {
    staticClass: "tab-list"
  }, _vm._l((_vm.tabPanes), function(tab, index) {
    return _c('li', {
      class: {
        'is-active': _vm.isActive(index), 'is-disabled': tab.disabled,
      },
      attrs: {
        "role": "tab"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.handleSelect(index)
        }
      }
    }, [_c('a', [(tab.icon) ? _c('span', {
      staticClass: "icon",
      class: {
        'is-small': _vm.size !== 'large'
      }
    }, [_c('i', {
      staticClass: "fa",
      class: [("fa-" + (tab.icon))]
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.label))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-content is-flex"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e76d1af4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/Tabs.vue
// module id = 358
// module chunks = 0